import { render } from "./g-catalog-category.vue?vue&type=template&id=186ce0ba&ts=true"
import script from "./g-catalog-category.vue?vue&type=script&lang=tsx"
export * from "./g-catalog-category.vue?vue&type=script&lang=tsx"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__